import { Injectable } from '@angular/core';
import { NavigationStart, Router } from '@angular/router';
import { Observable, filter, map } from 'rxjs';
import { BaseSiteConfigService } from '../base-site/base-site-config.service';

@Injectable({
  providedIn: 'root',
})
export class CachePageStateService {
  private enabledPages: Map<string, any> = new Map();
  private backBtnNavigated = false;

  constructor(private router: Router, private baseSiteConfigService: BaseSiteConfigService) {
    this.listenBackBtnEvent().subscribe((clicked: any) => {
      this.backBtnNavigated = clicked;
    });
  }

  enableCacheOnPage(page: string, data: any): void {
    const existingData = this.enabledPages.get(page) || {};
    const updatedData = { ...existingData, ...data };
    this.enabledPages.set(page, updatedData);
  }

  getCachedPage(page: string): any {
    this.clearOtherPage(page);
    return this.enabledPages.get(page);
  }

  /* DATA CLEAN UP - CLEAR OTHER PAGES */
  clearOtherPage(retainPage: string): void {
    const pagesToDelete = Array.from(this.enabledPages.keys()).filter((page) => page !== retainPage);
    for (const page of pagesToDelete) {
      this.clearPage(page);
    }
  }

  clearPage(page: string): void {
    this.enabledPages.delete(page);
  }

  listenBackBtnEvent(): Observable<any> {
    return this.router.events.pipe(
      filter((event: any) => event instanceof NavigationStart),
      map((navigationStart: any) => navigationStart.navigationTrigger === 'popstate')
    );
  }

  isNavigatedViaBackBtn(): boolean {
    return this.backBtnNavigated;
  }

  getPLPCachingEnabledConfig$(): Observable<any> {
    return this.baseSiteConfigService
      .getBaseSiteConfigValues$(['shimano.plp.caching.enabled'])
      .pipe(map((configs) => configs && configs.map((res: any) => res.value === 'true')[0]));
  }
}
